import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Profile, UserRole } from '@shared/models';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http: HttpClient = inject(HttpClient);
  public profile!: Profile;

  public isConnected: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public getMe(): Observable<Profile> {
    return this.http
      .get<Profile>(`${environment.api.root}/Me`)
      .pipe(tap((response: Profile) => (this.profile = response)));
  }

  public haveRole(roleId: number): boolean {
    return (
      this.profile.roles.findIndex((role: UserRole) => role.id === roleId) !==
      -1
    );
  }
}
